import { useLocation, useNavigate } from "react-router";
import './mobileNav.css';
import React, { useEffect, useState } from 'react';
const Footer = () => {

    const navigate = useNavigate();
    
    const scrollToTop = (value) => {
        navigate('/' + value);
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // Optional: for smooth scroll animation
        });
    };

    const [showSoon, setShowSoon] = useState(false);
     const handleAboutUsClick = (e) => {
        e.preventDefault();
        setShowSoon(true);
        setTimeout(() => setShowSoon(false), 1800);
    };



    return (
        <>
            <footer className="py-4 pb-0 bg-dark text-white header-font">
                <div className="container">
                    <div className="row">
                        <div className="col-md-3">
                            <h6 className="fw-bold text-orange">Twigaa.ai</h6>
                            <p className="small">Twigaa.ai is a travel-tech platform built for East African tour operators, helping you create, price, and share itineraries faster with multi-language and multi-currency support. From auto costing and room/child policy management (patent-pending) to circuit discounts, vouchers, CRM, accounts & P&L reports, and Xero integration, Twigaa.ai cuts down time, reduces errors, and improves customer and financial management—empowering you to deliver world-class travel experiences with ease.</p>
                        </div>
                        <div className="col-md-3">
                            <div className="quick-padd">
                                <h6 className="fw-bold text-orange">Quick Links</h6>
                                <ul className="list-unstyled small" style={{ lineHeight: '2rem' }}>
                                    <li><a onClick={() => scrollToTop('')} style={{ cursor: 'pointer' }}>Home</a></li>
                                    <li><a onClick={() => scrollToTop('faq')} style={{ cursor: 'pointer' }}>FAQs</a></li>
                                    <li><a onClick={() => scrollToTop('pricing-plans')} style={{ cursor: 'pointer' }}>Pricing</a></li>
                                    <li><a onClick={() => scrollToTop('blog')} style={{ cursor: 'pointer' }}>Blog</a></li>
                                    <li><a onClick={() => scrollToTop('about-us')} style={{ cursor: 'pointer' }}>About Us</a></li>
                                    

                                </ul>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="ps-0">
                                <h6 className="fw-bold text-orange">Privacy Policy & Terms of Service</h6>
                                <ul className="list-unstyled small">
                                    <li><a onClick={() => scrollToTop('privacypolicy')} style={{ cursor: 'pointer', fontWeight: '600' }}>Privacy Policy</a></li>
                                    <li><a onClick={() => scrollToTop('terms')} style={{ cursor: 'pointer', fontWeight: '600' }}>Terms of Service</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <h6 className="fw-bold text-orange">Contact Us</h6>
                            <ul className="list-unstyled small">
                                <li><a href="https://mail.google.com/mail/?view=cm&fs=1&to=info@twigaa.ai" target="_blank" rel="noreferrer" className="text-white">Email: info@twigaa.ai</a></li>
                                <li><a href="https://wa.me/+17324337081" target="_blank" rel="noopener noreferrer" className="text-white">Phone / WhatsApp : +1 732 433 7081</a></li>
                                <li><a href="https://wa.me/+254700789826" target="_blank" rel="noopener noreferrer" className="text-white">Phone / WhatsApp : +254 (0) 700 789 826</a></li>
                                <li style={{ fontSize: '1.1rem' }}>
                                    <a className="text-white" href="https://www.instagram.com/twigaaai" target="_blank" rel="noreferrer"><i className="fa-brands fa-instagram"></i></a>
                                    <a className="text-white ms-2" href="https://www.linkedin.com/company/97177389/admin/dashboard/" target="_blank" rel="noreferrer"><i className="fa-brands fa-linkedin"></i></a>
                                </li>
                            </ul>
                        </div>
                        <div className="col-12">
                            <p className="text-center mb-0 mt-3" style={{ color: '#f8f9fa82' }}>© {new Date().getFullYear()} Twigaa.ai. All rights reserved.</p>
                        </div>
                    </div>
                </div>
            </footer>
        </>

    );
}

export default Footer;